import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'bootstrap'
// import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'bootstrap-icons/font/bootstrap-icons.min.css'
import '@/assets/main.css'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import sweetalertMixin from './services/mix/sweetalert-mix'

import VueClipboard from 'vue3-clipboard'

import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import SmartTable from 'vuejs-smart-table'
import vTooltip from './plugins/v-tooltip';
import vPopover from './plugins/v-popover';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import Popper from "vue3-popper";

import './THSarabun-normal';
import './THSarabun-bold';

const app = createApp(App);
app.component("Popper", Popper);
app.directive('tooltip', vTooltip);
app.directive('popover', vPopover);
app.use(SmartTable)
app.use(VueSweetalert2)
app.mixin(sweetalertMixin);
app.use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true,
})
app.component("v-select", VueSelect)
app.component('VueDatePicker', VueDatePicker);
app.use(store)
app.use(router)
app.mount('#app')


// scp -r * root@122.155.27.98:/var/www/n-shift.wanorn.com/frontend
